import styled from 'styled-components'
/**
 * Common styles
 */
export const HeaderFilters = styled.div`
  align-self: end;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-top: 12px;
`
